import React from 'react';
import './HistoryScreen.css';
import xIcon from '../images/x_icon.svg'; // Adjust the path as necessary

interface HistoryScreenProps {
  isOpen: boolean;
  onClose: () => void;
  historyEntries: { title: string; content: any; timestamp: string }[]; // Update to accept objects with timestamp
  onSelectEntry: (entry: { title: string; content: any }) => void; // Update to accept objects
}

const HistoryScreen: React.FC<HistoryScreenProps> = ({ isOpen, onClose, historyEntries, onSelectEntry }) => {
  if (!isOpen) return null;

  return (
    <div className="history-popup">
      <div className="popup-content">
        <div className="history--header">
          <div className="history--title">
            <h2>History</h2>
          </div>
          <button className="close--button" onClick={onClose}>
            <img src={xIcon} alt="Close" width="16" height="16" />
          </button>
        </div>
        <ul className="history-list">
          {historyEntries.map((entry, index) => (
            <li key={index} className="history-item" onClick={() => onSelectEntry(entry)}> {/* Pass the entire entry */}
              <div>
                <strong>{entry.title}</strong>
                <span className="timestamp"> - {entry.timestamp}</span> {/* Display timestamp */}
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default HistoryScreen;